import type { RoundState } from '@magic/slot';

export const linesRound: RoundState[] = [
    {
        index: 0,
        type: 'reveal',
        board: [
            [
                {
                    name: 'H1',
                },
                {
                    name: 'L5',
                },
                {
                    name: 'H2',
                },
                {
                    name: 'L5',
                },
                {
                    name: 'L2',
                },
            ],
            [
                {
                    name: 'L4',
                },
                {
                    name: 'L5',
                },
                {
                    name: 'H2',
                },
                {
                    name: 'L5',
                },
                {
                    name: 'H2',
                },
            ],
            [
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L5',
                },
                {
                    name: 'H1',
                },
                {
                    name: 'H1',
                },
            ],
            [
                {
                    name: 'L3',
                },
                {
                    name: 'H1',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'L5',
                },
            ],
            [
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'H1',
                },
                {
                    name: 'L2',
                },
            ],
        ],
        paddingPositions: [182, 70, 163, 138, 176],
        gameType: 'basegame',
        anticipation: [0, 0, 0, 0, 0],
    },
    {
        index: 1,
        type: 'winInfo',
        totalWin: 40,
        wins: [
            {
                symbol: 'L5',
                kind: 3,
                win: 10,
                positions: [
                    {
                        reel: 0,
                        row: 1,
                    },
                    {
                        reel: 1,
                        row: 1,
                    },
                    {
                        reel: 2,
                        row: 2,
                    },
                ],
                meta: {
                    lineIndex: '6',
                    multiplier: 1,
                    winWithoutMult: 10,
                    globalMult: 1,
                    lineMultiplier: 1,
                },
            },
            {
                symbol: 'L5',
                kind: 3,
                win: 10,
                positions: [
                    {
                        reel: 0,
                        row: 3,
                    },
                    {
                        reel: 1,
                        row: 3,
                    },
                    {
                        reel: 2,
                        row: 2,
                    },
                ],
                meta: {
                    lineIndex: '7',
                    multiplier: 1,
                    winWithoutMult: 10,
                    globalMult: 1,
                    lineMultiplier: 1,
                },
            },
            {
                symbol: 'L5',
                kind: 3,
                win: 10,
                positions: [
                    {
                        reel: 0,
                        row: 1,
                    },
                    {
                        reel: 1,
                        row: 3,
                    },
                    {
                        reel: 2,
                        row: 2,
                    },
                ],
                meta: {
                    lineIndex: '16',
                    multiplier: 1,
                    winWithoutMult: 10,
                    globalMult: 1,
                    lineMultiplier: 1,
                },
            },
            {
                symbol: 'L5',
                kind: 3,
                win: 10,
                positions: [
                    {
                        reel: 0,
                        row: 3,
                    },
                    {
                        reel: 1,
                        row: 1,
                    },
                    {
                        reel: 2,
                        row: 2,
                    },
                ],
                meta: {
                    lineIndex: '17',
                    multiplier: 1,
                    winWithoutMult: 10,
                    globalMult: 1,
                    lineMultiplier: 1,
                },
            },
        ],
    },
    {
        index: 2,
        type: 'setWin',
        amount: 40,
        winLevel: 2,
    },
    {
        index: 3,
        type: 'setTotalWin',
        amount: 40,
    },
    {
        index: 4,
        type: 'finalWin',
        amount: 40,
    },
];
